// extracted by mini-css-extract-plugin
export default {"stock":"warehouseStockRenderCell_stock__448Pb","placeHolderShimmer":"warehouseStockRenderCell_placeHolderShimmer__KutjZ"};